import { Input, Select, Spin, message } from 'antd'
import FunctionalButton from 'components/ButtonV2/FunctionalButton'
import { useState } from 'react'
import { ApiCall } from 'services'
import { v4 as uuidv4 } from 'uuid'

const { Option } = Select

const SearchKVKForm = ({ initialValue, onHandle }) => {
  const [searchValue, setSearchValue] = useState(initialValue)
  const [fetching, setFetching] = useState(false)
  const [searchResults, setSearchResults] = useState([])
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [companyDomain, setCompanyDomain] = useState('')
  const [domainValidationErrors, setDomainValidationErrors] = useState('')

  const fetchCompanyData = async (value) => {
    setFetching(true)
    setSearchValue(value)

    if (value.length > 2) {
      try {
        const response = await ApiCall.searchKvk(value)

        setSearchResults(
          response.data.map((d) => {
            return { ...d, displayName: `${d.name} - KVK: ${d.kvk_number}` }
          }),
        )
      } catch (error) {
        console.error('Error fetching search results:', error)
      }
    } else {
      setSearchResults([])
    }

    setFetching(false)
  }

  const handleSelect = (value) => {
    const selected = searchResults.find((company) => company.name === value)

    setSelectedCompany(selected) // Store the selected company
  }

  const handleDomainChange = (e) => {
    setDomainValidationErrors('')
    setCompanyDomain(e.target.value)
  }

  const validateDomain = (domain) => {
    // Remove http/https if present
    const strippedDomain = domain.replace(/^(https?:\/\/)?/, '')

    // Simple regex to check if domain is in format: name.tld
    const domainPattern = /^[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/
    return domainPattern.test(strippedDomain)
  }

  const handleSubmit = (onHandle) => {
    if (!selectedCompany) {
      message.error('Please select a company.')
      return
    }

    if (!companyDomain || !validateDomain(companyDomain)) {
      setDomainValidationErrors(
        'Please enter a valid domain (e.g., traqqie.com).',
      )

      return
    }

    // Strip "http://" if the user accidentally adds it, and pass only the domain
    const cleanDomain = companyDomain.replace(/^(https?:\/\/)?/, '')

    // Pass the selected company and clean domain to the onHandle method
    const companyData = { ...selectedCompany, domain: cleanDomain }
    onHandle(companyData)
  }

  return (
    <>
      <Select
        showSearch
        value={selectedCompany?.name || searchValue}
        placeholder="Search for a company"
        className="search-kvk"
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={fetchCompanyData}
        onSelect={handleSelect}
        notFoundContent={
          fetching ? <Spin size="small" className="fill-g400" /> : null
        }
      >
        {searchResults.map((company) => (
          <Option
            key={`${company.kvk_number}-${company.name}-${uuidv4()}`}
            value={company.name}
          >
            {company.displayName}
          </Option>
        ))}
      </Select>

      {selectedCompany && (
        <div
          key="ll"
          className="wbso-question flex w-full flex-col gap-y-4"
          style={{ marginTop: '16px' }}
        >
          <p>
            To ensure that your company data is correctly linked, please enter
            your company's domain. This helps us verify your identity and keep
            your data secure. The domain should match the one used for your
            email ( e.g., <strong>traqqie.com</strong>).
          </p>
          <Input
            style={{ marginTop: '12px' }}
            placeholder="Enter company domain, e.g., google.com"
            value={companyDomain}
            vali
            onChange={handleDomainChange}
          />
          {domainValidationErrors && (
            <div style={{ color: 'red', marginTop: '8px' }}>
              {domainValidationErrors}
            </div>
          )}
        </div>
      )}

      {/* Conditionally render the submit button when authenticated */}
      {companyDomain && companyDomain && (
        <FunctionalButton type="primary" onClick={() => handleSubmit(onHandle)}>
          Next
        </FunctionalButton>
      )}
    </>
  )
}

export default SearchKVKForm
